import React, { useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";

const SectionSeven = () => {
  // export const SectionOne = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className="section-seven-cc">
      <div className="section-cc-seven">
        <div className="container-fluid">
          <div className="devspeed-container">
            <div className="devspeed-col-left">
              <div>
                <h1 className="sec-7-cc-head1" style={{ fontWeight: "500" }}>
                  Built for Developers.
                </h1>
                <h1 className="sec-7-cc-head2" style={{ fontWeight: "700" }}>
                  Engineered for Speed.
                </h1>
              </div>
              <div className="dev-speed-img-container">
                <img src="/assets/images/custom-checkout/devspeed.png" alt="" />
              </div>
            </div>
            <div className="devspeed-col-right">
              <div className="cc-net-card-7">
                <div className="cc-outer-sec7">
                  <div className="cc-inner-sec7 woo-net-card1">
                    <img
                      src="/assets/images/custom-checkout/cleardoc.png"
                      alt=""
                    />
                    <div>
                      <h5 style={{ color: "#191D23" }}>
                      Clear Docs & API Guidelines
                      </h5>
                      <p style={{ color: "#38485C" }}>
                       Well-structured documentation for smooth and hassle-free integration.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="cc-outer-sec7">
                  <div className="cc-inner-sec7 woo-net-card2">
                    <img
                      src="/assets/images/custom-checkout/dashboard.png"
                      alt=""
                    />
                    <div>
                      <h5 style={{ color: "#191D23" }}>
                       DIY Dashboard
                      </h5>
                      <p style={{ color: "#38485C" }}>
                        Full control to set up, test, and launch without waiting on dev effort.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="cc-outer-sec7">
                  <div className="cc-inner-sec7 woo-net-card3">
                    <img
                      src="/assets/images/custom-checkout/custom.png"
                      alt=""
                    />
                    <div>
                      <h5 style={{ color: "#191D23" }}>
                        Custom Everything
                      </h5>
                      <p style={{ color: "#38485C" }}>
                       Adapt checkout flows to your unique business logic and brand guidelines.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="cc-outer-sec7">
                  <div className="cc-inner-sec7 woo-net-card3">
                    <img
                      src="/assets/images/custom-checkout/faster.png"
                      alt=""
                    />
                    <div>
                      <h5 style={{ color: "#191D23" }}>
                        Faster Time to Market
                      </h5>
                      <p style={{ color: "#38485C" }}>
                       Lightweight APIs and modular design mean you go live faster.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="cc-outer-sec7">
                  <div className="cc-inner-sec7 woo-net-card3">
                    <img
                      src="/assets/images/custom-checkout/modular.png"
                      alt=""
                    />
                    <div>
                      <h5 style={{ color: "#191D23" }}>
                        Modular Architecture
                      </h5>
                      <p style={{ color: "#38485C" }}>
                        Pick and implement only what you need, without bloat.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionSeven;
